const TRANSPARENT_ICON =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";

/** Creates a cluster lifecycle around an injected markerclustererplus constructor and Maps API. */
export function createMapClusters({ maps, map, markers, Clusterer, selectedIcon, open }) {
  const clusterer = new Clusterer(map, markers, {
    zoomOnClick: false,
    ignoreHidden: true,
    averageCenter: true,
    styles: [
      {
        className: "pin-cluster pin-cluster-with-count",
        width: 50,
        height: 60,
        anchorIcon: [60, 25],
        textColor: "inherit",
        textSize: 12,
        anchorText: [-5, 5],
      },
    ],
  });
  const anchor = new maps.Marker({
    map,
    clickable: false,
    icon: { url: TRANSPARENT_ICON, scaledSize: new maps.Size(50, 60) },
  });
  let highlighted;
  let highlightMarker;
  let highlightClick;
  let bounce;
  let originalVisibility;
  let disposed = false;
  const listeners = [
    maps.event.addListener(clusterer, "click", openCluster),
    maps.event.addListener(clusterer, "clusteringbegin", unhighlight),
  ];

  function forMarker(marker) {
    return clusterer
      .getClusters()
      .find((cluster) => cluster.getMarkers().length > 1 && cluster.getMarkers().includes(marker));
  }

  function openCluster(cluster) {
    if (!disposed && cluster) {
      anchor.setPosition(cluster.getCenter());
      open(cluster.getMarkers(), anchor);
    }
  }

  function openHighlighted() {
    openCluster(highlighted);
  }

  function stopBounce() {
    highlightMarker?.setAnimation(null);
    bounce = undefined;
  }

  function highlight(cluster) {
    if (disposed || !cluster || highlighted === cluster) {
      return;
    }
    unhighlight();
    highlighted = cluster;
    // markerclustererplus exposes no public cluster-icon visibility API.
    const element = cluster.clusterIcon_?.div_;
    originalVisibility = element?.style.visibility;
    if (element) {
      element.style.visibility = "hidden";
    }
    highlightMarker = new maps.Marker({
      map,
      position: cluster.getCenter(),
      zIndex: markers.length + 1,
      icon: { url: selectedIcon, scaledSize: new maps.Size(50, 60) },
    });
    highlightClick = highlightMarker.addListener("click", openHighlighted);
    highlightMarker.setAnimation(maps.Animation.BOUNCE);
    bounce = setTimeout(stopBounce, 750);
  }

  function unhighlight() {
    clearTimeout(bounce);
    bounce = undefined;
    highlightClick?.remove();
    highlightClick = undefined;
    highlightMarker?.setAnimation(null);
    highlightMarker?.setMap(null);
    highlightMarker = undefined;
    const element = highlighted?.clusterIcon_?.div_;
    if (element) {
      element.style.visibility = originalVisibility ?? "";
    }
    highlighted = undefined;
  }

  function dispose() {
    if (disposed) {
      return;
    }
    disposed = true;
    unhighlight();
    listeners.forEach((listener) => listener?.remove());
    clusterer.clearMarkers();
    clusterer.setMap(null);
    anchor.setMap(null);
  }

  return Object.freeze({ anchor, forMarker, open: openCluster, highlight, unhighlight, dispose });
}
